import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import "../../styles/CatalogPagination.css";

function buildPageButtons(page, total) {
  if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);

  const first = [1, 2, 3, 4];
  const last = total;

  if (page <= 4) return [...first, "...", last];

  if (page >= total - 2) {
    return [1, "...", total - 3, total - 2, total - 1, total].filter(Boolean);
  }

  return [1, "...", page - 1, page, page + 1, "...", last];
}

export default function CatalogPagination({
  page,
  totalPages,
  onPageChange,
  onMore,
  showMore = true,
  moreDisabled = false,
}) {
  const { t } = useTranslation("catalog");

  const pageButtons = useMemo(
    () => buildPageButtons(page, totalPages),
    [page, totalPages]
  );

  if (!totalPages || totalPages <= 1) return null;

  return (
    <div className="catPager">
      {showMore && (
        <button
          type="button"
          className="catMoreBtn"
          onClick={onMore}
          disabled={moreDisabled}
        >
          {t("more_products")}
        </button>
      )}

      <div
        className="catPageRow"
        role="navigation"
        aria-label={t("pagination")}
      >
        {pageButtons.map((x, idx) => {
          if (x === "...") {
            return (
              <div key={`dots-${idx}`} className="catDots">
                …
              </div>
            );
          }

          const n = Number(x);
          const active = n === page;

          return (
            <button
              key={n}
              type="button"
              className={`catPageBtn ${active ? "isActive" : ""}`}
              onClick={() => onPageChange?.(n)}
            >
              {n}
            </button>
          );
        })}
      </div>
    </div>
  );
}